enum SurveyQuestionItemTypeEnum {
    descriptive, alternative
}

export default SurveyQuestionItemTypeEnum;